import { EmptyContent } from '@/components'
import {
  Box,
  Stack,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material'
import Image from 'next/image'
import { PREFIX_URL } from '../../utils/common'
import { parseTableToObjects } from '../../utils/sizes'
import { SIZE_CHART } from '../sizes/data-sample'
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  padding: '8px 12px',
  fontWeight: 300,
  borderRight: '1px solid #BBBBBA',
  '&:last-child': {
    borderRight: 'none',
  },
}))
export const SizesTable = ({ listSizes, product }: { listSizes: typeof SIZE_CHART; product: Product }) => {
  const sizesTable = parseTableToObjects(product?.size_chart || '')

  // Lấy headers từ object đầu tiên
  const headers = sizesTable.length > 0 ? Object.keys(sizesTable[0]) : []

  // Kiểm tra nếu không có data
  if (!sizesTable || sizesTable.length === 0 || headers.length === 0) {
    return (
      <Stack
        rowGap={2}
        spacing={2}
        alignItems={'center'}
        justifyContent={'center'}
        minHeight={'400px'}
        height={'100%'}
      >
        {product?.size_chart_image && (
          <Box sx={{ flexShrink: 0 }}>
            <Image
              src={PREFIX_URL + product?.size_chart_image}
              alt="Size chart"
              width={232}
              height={180}
              style={{ objectFit: 'contain' }}
            />
          </Box>
        )}
        <EmptyContent title={'Không có thông tin bảng size'} />
      </Stack>
    )
  }

  return (
    <Stack rowGap={2} spacing={2} alignItems={'center'}>
      {product?.size_chart_image && (
        <Box sx={{ flexShrink: 0 }}>
          <Image
            src={PREFIX_URL + product?.size_chart_image}
            alt="Size chart"
            width={232}
            height={180}
            style={{ objectFit: 'contain' }}
          />
        </Box>
      )}
      <Box
        sx={{
          border: '1px solid #BBBBBA',
          borderRadius: '8px',
          overflow: 'hidden',
          flex: 1,
          width: '100%',
          minWidth: '300px',
        }}
      >
        {/* MUI Table */}
        <TableContainer>
          <Table sx={{ minWidth: 300 }}>
            <TableHead>
              <TableRow
                sx={{
                  backgroundColor: '#F5F5F5',
                  '& th': {
                    borderBottom: 'none',
                    fontWeight: 600,
                  },
                }}
              >
                {headers.map((header, index) => (
                  <StyledTableCell key={header} align="center" sx={{ fontWeight: index === 0 ? 600 : 400 }}>
                    {header}
                  </StyledTableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {sizesTable.map((row, rowIndex) => (
                <TableRow key={rowIndex} sx={{ '&:last-child td, &:last-child th': { borderBottom: 0 } }}>
                  {headers.map((header, colIndex) => (
                    <StyledTableCell
                      key={header}
                      component={colIndex === 0 ? 'th' : 'td'}
                      scope={colIndex === 0 ? 'row' : undefined}
                      align="center"
                      sx={{ fontWeight: colIndex === 0 ? 600 : 300 }}
                    >
                      {row[header] || '-'}
                    </StyledTableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Stack>
  )
}
